import { Row, Col } from "../../App.styles";

const TimingSection = ({ useQuery }) => {
  const { starts_at, ends_at } = useQuery();
  const formatter = new Intl.DateTimeFormat("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  });

  return (
    <>
      {starts_at && (
        <Row>
          <Col>
            <p>Starts at: {formatter.format(new Date(starts_at))}</p>
          </Col>
        </Row>
      )}
      {ends_at && (
        <Row>
          <Col>
            <p>Ends at: {formatter.format(new Date(ends_at))}</p>
          </Col>
        </Row>
      )}
    </>
  );
};

export default TimingSection;
